import Container from "../element/container";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { getExteriorGallery } from "../../helpers/product.media";
import { DcLogo } from "../../assets/images";
import Image from "../element/image";
import "swiper/css";
import "swiper/css/pagination";

export default function ProductCardCarousel({ media, name }) {
  const swiperRef = useRef(null);
  const gallery = getExteriorGallery(media);
  if (gallery.length < 2) {
    return <Image className={`_img ${gallery.length ? "" : "default"}`} src={gallery[0]?.url || DcLogo} alt={name} />;
  }
  return (
    <Container tag="div" className="product-card-carousel" onClick={(event) => {
      if (!swiperRef.current?.allowClick || event.target.closest("button, .swiper-pagination")) event.stopPropagation();
    }}>
      <Swiper
        touchStartPreventDefault={false}
        key={gallery[0]?.url}
        nested
        loop
        slidesPerView={1}
        modules={[Pagination]}
        // Nested in another swiper, this one can be measured before its parent
        // slide has a width, which leaves every photo laid out in a row.
        observer
        observeParents
        observeSlideChildren
        watchOverflow
        pagination={{ clickable: true, dynamicBullets: true, dynamicMainBullets: 5 }}
        onSwiper={(swiper) => { swiperRef.current = swiper; }}
      >
        {gallery.map((image, index) => (
          <SwiperSlide key={image.image_id || image.url || index}>
            <Image className="_img" src={image.url} alt={`${name || "Vehicle"} — exterior ${index + 1}`} />
          </SwiperSlide>
        ))}
      </Swiper>
      <button type="button" className="product-carousel-arrow previous" aria-label="Previous vehicle photo"
        onClick={(event) => { event.stopPropagation(); swiperRef.current?.slidePrev(); }}>‹</button>
      <button type="button" className="product-carousel-arrow next" aria-label="Next vehicle photo"
        onClick={(event) => { event.stopPropagation(); swiperRef.current?.slideNext(); }}>›</button>
    </Container>
  );
}
